/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const CancelFintocPayment = () => gql`
  mutation CancelFintocPayment($params: CancelFintocPaymentParams!) {
    cancelFintocPayment(params: $params) {
      id
      deliveryType
      deliveryCost
      totalCost
      mekiCreditsUsed
      onDemand
      payments {
        id
        status
        amount
        paymentMethodType
      }
      address {
        id
        uuid
        apartment
        commune
        street
        streetNumber
        details
        name
      }
      paymentMethod {
        id
        uuid
        type
        data
      }
      status
      orderGroupId
      paidAt
      orderDetails {
        id
        quantity
        price
        product {
          id
          name
          concentration
          quantity
          unit
          format
          imagesUrl
          display
          price
          prescriptionType
          metadata {
            refrigerated
          }
        }
      }
    }
  }
`;

export type CancelFintocPaymentParams = ResolverParams<{
  orderUuid: string;
}>;

export type CancelFintocPaymentResponse = {
  cancelFintocPayment: Order;
};
